import React from "react";
import style from "./index.module.scss";
import { Button, Dropdown, Icon, Menu } from "antd";
import classNames from "classnames";
import useBatchPicker from "../../../../utils/useBatchPicker";
import { Link } from "react-router-dom";
import { useAtomValue } from "jotai";
import { studentEvaluationStatusAtom, termListAtom } from "../../../../store";
import { Badge } from "antd-mobile";

interface BatchPickerProps {
    showResetBtn: boolean; // 是否显示回到本周按钮
    onResetWeek: () => void; // 回到本周
    showCourseListLink: boolean;
    showSchedule: boolean;
}

export default function BatchPicker({
    showResetBtn,
    onResetWeek,
    showCourseListLink,
    showSchedule
}: BatchPickerProps) {
    const batchList = useAtomValue(termListAtom);
    const { batch, handleChangeBatch } = useBatchPicker();
    const isEvaluation = useAtomValue(studentEvaluationStatusAtom);

    const menu = (
        <Menu className={style.menu}>
            {batchList?.map(item => (
                <Menu.Item
                    key={item.batchNo}
                    onClick={() => handleChangeBatch(item.batchNo)}
                    className={classNames(style.menuItem, {
                        [style.selected]: item.batchNo === batch
                    })}>
                    {item.batchName}
                </Menu.Item>
            ))}
        </Menu>
    );

    return (
        <div className={style.root}>
            <Dropdown
                overlay={menu}
                className={style.dropdown}
                trigger={["click"]}>
                <div>
                    {batchList?.find(item => item.batchNo === batch)?.batchName}{" "}
                    <Icon type="down" />
                </div>
            </Dropdown>

            <div className={style.operate}>
                {showResetBtn && (
                    <Button
                        type="link"
                        className={classNames(style.reset, style.marginLeft)}
                        onClick={onResetWeek}>
                        回到今天
                    </Button>
                )}
                {showCourseListLink && (
                    <Link
                        className={classNames(
                            style.courseListLink,
                            style.marginLeft
                        )}
                        to={"/course/list"}>
                        <Badge dot={isEvaluation}>
                            <img
                                src={require("./images/courseListIcon.png")}
                                alt=""
                            />
                        </Badge>
                    </Link>
                )}
                {showSchedule && (
                    <Link
                        className={classNames(
                            style.scheduleLink,
                            style.marginLeft
                        )}
                        to={"/"}>
                        <img src={require("./images/schedule.png")} alt="" />
                    </Link>
                )}
            </div>
        </div>
    );
}

BatchPicker.defaultProps = {
    showCourseListLink: false,
    showSchedule: false
};
